export enum SubmissionStatus {
    Draft = 1,
    InProgress = 2,
    Submitted = 3,
    Completed = 4,
}

export enum PersonalStatus {
    Single = 1,
    Married = 2,
    RegistedDomesticPartner = 3,
    Widowed = 4,
    Divorced = 5,
    TerminatedDomesticPartnership = 6
}

export enum BeneficiaryRelation {
    Spouse = 1,
    RegisteredDomesticPartner = 2,
    MinorDependentChild = 3,
    EntityTrustOrg = 4,
    InsurableInterest = 5,
    Others = 6,
    Person = 7,
    // NoEligibleBeneficiary = 8
}

export enum BeneficiaryPaymentOption {
    UnmodifiedAllowance = 1,
    Option1 = 2,
    Option2 = 3,
    Option3 = 4,
    Option4 = 5,
}

export enum AccountType {
    CheckingAccount = 1,
    SavingsAccount = 2,
}
export enum SupportDocs {
    BirthCertificateMember = 'Birth Certificate',
    MarriageCertificate = 'Marriage Certificate',
    BirthCertificateSpouse = 'Birth Certificate - Spouse',
    BirthCertificatePartner = 'Birth Certificate - Partner',
    CertificateOfDomesticPartnership = 'Certificate of Domestic Partnership',
    ACourtEndorsedDomesticRelationsOrderDRO = 'A Court Endorsed Domestic Relations Order (DRO)',
    DeathCertificateSpouse = 'Death Certificate - Spouse',
    DirectDepositAuthorizationVoidedCheck = 'Direct Deposit Authorization - Voided Check',
    CertifiedBankLetterOrSavingsAccountStatement = 'Direct Deposit Authorization - Certified Bank Letter or Savings Account Statement',
    TemporaryAnnuitiesEstimateFromSocialSecurityOffice = 'Social Security Estimate for Temporary Annuity',
    BeneficiariesBirthCertificates = 'Birth Certificate - Retirement Benefit - Beneficiary ',
    Other = 'Other',
}